<template>
  <div class="dialogBox">
    <el-dialog
      title="添加考生"
      :visible.sync="addMemberVisible"
      width="30%"
      @closed="addMemberClosed"
    >
      <!-- 条件筛选框 -->
      <div class="waitingcom_title">
        <el-form
          :model="formLabelAlign"
          ref="formLabelAlign"
          :label-position="labelPosition"
        >
          <el-row :gutter="20">
            <el-col :span="8" :offset="0">
              <el-form-item label="考生姓名：">
                <el-input
                  v-model.trim="formLabelAlign.RealName"
                  placeholder="请输入考生姓名"
                ></el-input></el-form-item
            ></el-col>
            <el-col :span="8" :offset="0"
              ><el-form-item label="考生账号：">
                <el-input
                  v-model.trim="formLabelAlign.UserName"
                  placeholder="请输入考生账号"
                ></el-input></el-form-item
            ></el-col>
            <el-col :span="8" :offset="0"
              ><el-form-item label="科室：">
                <el-select
                  v-model="formLabelAlign.DepartmentName"
                  placeholder="全部"
                  @change="handleQuery"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option
                    v-for="item in departmentList"
                    :key="item.departmentid"
                    :label="item.DepartmentName"
                    :value="item.DepartmentName"
                  ></el-option>
                </el-select> </el-form-item
            ></el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="8" :offset="0"
              ><el-form-item label="职称：">
                <el-select
                  v-model="formLabelAlign.PTitle"
                  placeholder="全部"
                  @change="handleQuery"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option
                    v-for="item in pTitleList"
                    :key="item.PTitle"
                    :label="item.PTitle"
                    :value="item.PTitle"
                  ></el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="8" :offset="0">
              <el-form-item label="用户组：">
                <el-select
                  v-model="formLabelAlign.groupID"
                  placeholder="全部"
                  @change="handleQuery"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option
                    v-for="item in groupList"
                    :key="item.groupID"
                    :label="item.groupName"
                    :value="item.groupID"
                  ></el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="8" :offset="0">
              <el-form-item label=" ">
                <el-button
                  @click="handleQuery"
                  type="primary"
                  icon="el-icon-search"
                  >搜索</el-button
                >
                <el-button @click="resetQuery" icon="el-icon-refresh"
                  >重置</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <!-- 表格内容 -->
      <div class="t_table t_scroll">
        <el-table
          ref="table"
          :data="getData"
          :row-class-name="tableRowClassName"
          @selection-change="handleSelectionChange"
          @row-click="stepsListRowClick"
          :row-key="getRowKeyOfTarget"
          :header-cell-style="{
            'background-color': '#8FCBFF',
            color: '#333333',
            height: '60px',
          }"
          v-loading="isLoading"
        >
          <el-table-column
            type="selection"
            width="60"
            :reserve-selection="true"
          ></el-table-column>

          <el-table-column label="序号" type="index" width="100"
            ><template slot-scope="scope">
              <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column label="考生账号">
            <template slot-scope="scope">
              {{ scope.row.UserName }}
            </template>
          </el-table-column>

          <el-table-column label="考生姓名">
            <template slot-scope="scope">
              {{ scope.row.RealName }}
            </template>
          </el-table-column>

          <el-table-column label="账户类型">
            <template slot-scope="scope">
              {{ scope.row.UserTypeCN }}
            </template>
          </el-table-column>

          <el-table-column label="科室名称">
            <template slot-scope="scope">
              {{ scope.row.DepartmentName }}
            </template>
          </el-table-column>

          <el-table-column label="职称">
            <template slot-scope="scope">
              {{ scope.row.PTitle }}
            </template>
          </el-table-column>

          <el-table-column label="职位">
            <template slot-scope="scope">
              {{ scope.row.Position }}
            </template>
          </el-table-column>

          <el-table-column label="出生年月日">
            <template slot-scope="scope">
              {{
                scope.row.Birthday == null
                  ? null
                  : $moment(scope.row.Birthday).format("YYYY-MM-DD")
              }}
            </template>
          </el-table-column>

          <el-table-column label="工作年限">
            <template slot-scope="scope">
              {{ scope.row.JobDate }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="foot_box">
        <div class="foot_pagetions">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :page-sizes="pagesizesArr"
            layout="prev, pager, next, sizes, jumper"
            :total="total"
            class="pagination"
          ></el-pagination>
        </div>
      </div>

      <!-- 底部操作按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addMemberVisible = false">取 消</el-button>
        <el-button type="primary" @click="addMember()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import noticeApi from "@/api/notice";
export default {
  data() {
    return {
      // 弹窗吊起定义
      addMemberVisible: false,
      // 条件筛选框全局定义
      labelPosition: "right",
      formLabelAlign: {
        RealName: "",
        UserName: "",
        DepartmentName: "",
        PTitle: "",
        groupID: "",
      },
      departmentList: [],
      positionList: [],
      pTitleList: [],
      groupList: [],
      // 表格定义
      isLoading: false,
      multipleSelectionIds: [],
      multipleSelection: [],
      multipleSelectionCount: 0,
      getDataCondition: {
        RealName: "",
        UserName: "",
        DepartmentName: "",
        PTitle: "",
        groupID: "",
      },
      getData: [],
      currentPage: 1,
      pageSize: 5,
      pagesizesArr: [5, 10, 20, 50, 100],
      total: 0,
    };
  },
  methods: {
    // 弹窗关闭触发
    addMemberClosed() {},
    // 条件筛选按钮
    handleQuery() {
      this.$refs.table.clearSelection();
      this.currentPage = 1;
      if (this.formLabelAlign.RealName) {
        this.getDataCondition.RealName = this.formLabelAlign.RealName;
      } else {
        this.getDataCondition.RealName = "";
      }
      if (this.formLabelAlign.UserName) {
        this.getDataCondition.UserName = this.formLabelAlign.UserName;
      } else {
        this.getDataCondition.UserName = "";
      }
      if (this.formLabelAlign.DepartmentName) {
        this.getDataCondition.DepartmentName =
          this.formLabelAlign.DepartmentName;
      } else {
        this.getDataCondition.DepartmentName = "";
      }
      if (this.formLabelAlign.PTitle) {
        this.getDataCondition.PTitle = this.formLabelAlign.PTitle;
      } else {
        this.getDataCondition.PTitle = "";
      }
      if (this.formLabelAlign.groupID) {
        this.getDataCondition.groupID = this.formLabelAlign.groupID;
      } else {
        this.getDataCondition.groupID = "";
      }
      this.getStudentLists();
    },
    // 条件重置按钮
    resetQuery() {
      this.formLabelAlign = {
        RealName: "",
        UserName: "",
        DepartmentName: "",
        PTitle: "",
        groupID: "",
      };
      this.$refs.table.clearSelection();
      this.currentPage = 1;
      this.getDataCondition = {
        RealName: "",
        UserName: "",
        DepartmentName: "",
        PTitle: "",
        groupID: "",
      };
      this.getStudentLists();
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 表格多选框改变时触发
    handleSelectionChange(rows) {
      // 初始化全局表格多选框
      this.multipleSelectionIds = [];
      this.multipleSelection = [];
      this.multipleSelectionCount = 0;
      // 将数据存入
      rows.forEach((row) => {
        this.multipleSelectionIds.push(row.UserID);
      });
      this.multipleSelection = rows;
      this.multipleSelectionCount = this.multipleSelection.length;
    },
    // 勾选当前行激活check
    stepsListRowClick(row, column, event) {
      this.$refs.table.toggleRowSelection(row);
    },
    // 给每一行设置key
    getRowKeyOfTarget(row) {
      return row.UserID;
    },
    // 每页大小改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getStudentLists();
    },
    // 切换页数后触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getStudentLists();
    },
    // 基本请求参数工具
    baseReqParamUtils(paraObj) {
      paraObj.hid = parseInt(this.$store.state.hid);
      paraObj.userID = parseInt(this.$store.state.userID);
      paraObj.guid = this.$store.state.user;
      return paraObj;
    },
    // 获取考生列表
    async getStudentLists() {
      this.isLoading = true;
      const reqParam = this.baseReqParamUtils(new Object());
      reqParam.showMode = "hospital";
      reqParam.pageIndex = this.currentPage - 1;
      reqParam.pageShow = this.pageSize;

      reqParam.realName = this.getDataCondition.RealName;
      reqParam.userName = this.getDataCondition.UserName;
      reqParam.departmentName = this.getDataCondition.DepartmentName;
      reqParam.pTitle = this.getDataCondition.PTitle;
      reqParam.group = this.getDataCondition.groupID;

      console.log(reqParam, "获取考生列表请求数据");
      const { data } = await noticeApi.getStudentList(reqParam);
      console.log(data, "获取考生列表响应数据");
      if (data.Status == 200) {
        this.getData = data.Data[0];
        this.total = data.Data[1][0].dataCount;
        this.departmentList = data.Data[2];
        this.positionList = data.Data[3];
        this.pTitleList = data.Data[4];
        this.isLoading = false;
      } else {
        this.$message.error(data.Data);
        this.isLoading = false;
      }
    },
    // 添加考生
    async addMember() {
      if (this.multipleSelectionCount <= 0) {
        this.$message.error("请选择考生");
        return;
      }
      this.$parent.allDataIds = this.multipleSelectionIds;
      this.$parent.allData = this.multipleSelection;
      this.$parent.total = this.multipleSelectionCount;
      this.$parent.getStudentLists();
      this.addMemberVisible = false;
    },
  },
  created() {
    this.getStudentLists();
  },
};
</script>

<style lang="scss" scoped>
// 弹窗整体css
.dialogBox {
  box-sizing: border-box;
  ::v-deep .el-dialog__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .el-dialog {
    width: 1274px !important;
    background: #ffffff;
    opacity: 1;
    border-radius: 5px;
    .el-dialog__header {
      height: 55px;
      background: linear-gradient(
        180deg,
        #64b5ff 0%,
        rgba(199, 228, 255, 1) 100%
      );
      opacity: 1;
      border-radius: 5px 5px 0px 0px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
    }
    .el-dialog__body {
      padding: 0px 20px;
    }
    .el-dialog__footer {
      text-align: center;
      margin-top: 10px;
      margin-bottom: 30px;
      .el-button {
        width: 120px;
        height: 50px;
        opacity: 1;
        border-radius: 4px;
        margin-left: 0px;
        margin-right: 100px;
      }
      & .el-button:last-child {
        margin-right: 0px;
      }
    }
  }
}

// 条件筛选框css
.waitingcom_title {
  padding: 24px 24px 16px 10px;
  border-bottom: 1px solid #f8f8f8;
  .el-form {
    .el-select {
      width: 100%;
    }
    .el-form-item {
      display: flex;
    }
    ::v-deep .el-form-item__label {
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      min-width: 88px;
    }
    ::v-deep .el-form-item__content {
      flex-grow: 1;
    }
    .el-row:last-child > .el-col:last-child > .el-form-item:last-child {
      .el-button {
        width: 88px;
        height: 40px;
        margin-right: 24px;
      }
      & .el-button:last-child {
        margin-right: 0px;
      }
    }
  }
}

// 表格内容css
.t_table {
  margin-top: 24px;
  padding: 0px 24px;
  height: 346px;
  min-height: 346px;
  ::v-deep .cell {
    text-align: center;
  }
}

// 表格滚动条
.t_scroll {
  overflow-y: scroll;
  scrollbar-face-color: none !important;
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 4px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    //  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
  }
  & ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
  }
}

::v-deep .el-table__row {
  height: 50px !important;
  td,
  th {
    padding: 0 !important;
  }
}

::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}

// 分页
.foot_box {
  position: relative;
  height: 88px;
  .foot_pagetions {
    display: flex;
    position: absolute;
    right: 16px;
    bottom: 30px;
    span {
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      b {
        color: #ff0000;
      }
    }
    .pagination {
      ::v-deep .el-pager {
        li {
          border: 1px solid #d9d9d9;
          margin-right: 8px;
          &.active {
            color: #ffffff;
            background-color: #409eff;
            border: none;
          }
        }
      }
      ::v-deep .el-pagination__jump {
        margin: 0px 10px 0px 0px !important;
      }
    }
  }
}
</style>